import { render, staticRenderFns } from "./DataProfile.vue?vue&type=template&id=28a669d2&scoped=true&"
import script from "./DataProfile.vue?vue&type=script&lang=js&"
export * from "./DataProfile.vue?vue&type=script&lang=js&"
import style0 from "./DataProfile.vue?vue&type=style&index=0&id=28a669d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a669d2",
  null
  
)

export default component.exports